import React from 'react'

const DownloadIcon = () => {
  return (
      <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
      >
          <path d="M17 17H1M14.3333 8.11111L9 13.4444M9 13.4444L3.66667 8.11111M9 13.4444V1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
  )
}

export default DownloadIcon